import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  headline: {
    id: 'GeoCountryLayer.Headline',
    defaultMessage: 'Herzlich willkommen auf',
  },
  info: {
    id: 'GeoCountryLayer.Info',
    defaultMessage:
      'Bitte beachte, dass in diesem Onlineshop <b>nur Lieferungen nach Deutschland</b> möglich sind.',
  },
  footer: {
    id: 'GeoCountryLayer.Footer',
    defaultMessage: 'Weiter auf {spacer}{link}{spacer} shoppen',
  },
  description: {
    id: 'GeoCountryLayer.Description',
    defaultMessage:
      'Entdecke tolle Rabatte, Tipps und Aktionen, die einen Besuch noch abwechslungsreicher machen. Reinschauen lohnt sich!',
  },
  // * dummy messsage ids, they are here to avoid cli locales to remove the translation from locales/messages folder  * //
  description_de: {
    id: 'GeoCountryLayer.Description.de',
  },
  description_at: {
    id: 'GeoCountryLayer.Description.at',
  },
  description_ch: {
    id: 'GeoCountryLayer.Description.ch',
  },
  description_it: {
    id: 'GeoCountryLayer.Description.it',
  },
  button: {
    id: 'GeoCountryLayer.Button',
    defaultMessage: 'Weiter im Shop',
  },
  // **** //
  // * dummy messsage ids, they are here to avoid cli locales to remove the translation from locales/messages folder  * //
  button_de: {
    id: 'GeoCountryLayer.Button.de',
  },
  button_at: {
    id: 'GeoCountryLayer.Button.at',
  },
  button_ch: {
    id: 'GeoCountryLayer.Button.ch',
  },
  button_it: {
    id: 'GeoCountryLayer.Button.it',
  },
  // **** //
});
